module.exports = __webpack_public_path__ + "img/nevernot-logo.2956d54d.jpg";